import helper from './helper'

export default {
  async getById(id) {
    return await helper.get(`/api/channel-viewing-slots/${id}`)
  },
  async getByChannel(id) {
    return await helper.post(`/api/channel-viewing-slots/by-channel`, {
      channel_id: id
    })
  },
  async create(item) {
    return await helper.post(`/api/channel-viewing-slots`, item)
  },
  async update(item) {
    return await helper.put(`/api/channel-viewing-slots`, item)
  },
  async remove(item) {
    return await helper.delete(`/api/channel-viewing-slots/${item.id}`)
  }
}
